var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-navbar',{attrs:{"breadcrumb":_vm.breadcrumb}}),_vm._v(" "),_c('div',{staticClass:"container-fluid mt--6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('change-password-notice-card')],1),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('change-password-card')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }